import type { SupportTicketId } from "@redotech/effect-api-shared/ids/definitions";
import type { ChannelThread } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatThreadView } from "./chat-thread-view";

interface TiktokThreadViewProps {
  supportTicketId: SupportTicketId;
  thread: ChannelThread;
}

export const TiktokThreadView = memo(function TiktokThreadView({
  supportTicketId,
  thread,
}: TiktokThreadViewProps) {
  return (
    <ChatThreadView
      channel="tiktok"
      supportTicketId={supportTicketId}
      thread={thread}
    />
  );
});
